import PropTypes from "prop-types";
import { useMemo } from "react";
import "./styles.scss";

export default function MessageCell({ payload }) {
  const msgText = useMemo(() => {
    if (typeof payload === "object" && payload !== null) return JSON.stringify(payload);
    return String(payload ?? "");
  }, [payload]);

  return (
    <div className="ocpp-msg-wrap">
      <span className="ocpp-msg-ellipsis" title={msgText}>
        {msgText}
      </span>
    </div>
  );
}

MessageCell.propTypes = {
  payload: PropTypes.any,
};
